import { DataLayerPush, GA, Intercom, GTagTrackEvent, EncTracking, getUserIP } from './analytics-tools';

import { getCurrentTeam, getCurrentUser } from './store-service';
import { getRoleLabel } from '../utils/user';

import config from '../config';

let trackingBlocked = false;

const trackConsts = {
    'TEAM.REMOVE': {
        ga: {
            category: 'Team',
            action: 'Team removed'
        },
        intercom: {
            action: 'Team removed'
        }
    },
    'TEAM.URL_CHANGE': {
        ga: {
            category: 'Team',
            action: 'Team url changed'
        },
        intercom: {
            action: 'Team url changed'
        }
    },
    'TEAM.USER_ROLE_CHANGE': {
        ga: {
            category: 'Team',
            action: 'Team user role changed'
        },
        intercom: {
            action: 'Team user role changed'
        }
    },
    'TEAM.PLAN_CHANGE': {
        ga: {
            category: 'Team',
            action: 'Team plan changed'
        },
        intercom: {
            action: 'Team plan changed'
        }
    },
    'PROJECT.CREATE': {
        ga: {
            category: 'Project',
            action: 'Project Created'
        },
        intercom: {
            action: 'Project Created'
        },
        encharge: {
            name: 'Project Created'
        }
    },
    'PROJECT.EDIT': {
        ga: {
            category: 'Project',
            action: 'Project edited'
        },
        intercom: {
            action: 'Project edited'
        }
    },
    'PROJECT.MEMBER_REMOVE': {
        ga: {
            category: 'Project',
            action: 'Project member removed'
        },
        intercom: {
            action: 'Project member removed'
        }
    },
    'PROJECT.ARCHIVE': {
        ga: {
            category: 'Project',
            action: 'Project archived'
        },
        intercom: {
            action: 'Project archived'
        }
    },
    'DISCUSSION.EDIT': {
        ga: {
            category: 'Discussion',
            action: 'Discussion edited'
        },
        intercom: {
            action: 'Discussion edited'
        }
    },
    'DISCUSSION.USER_INVITE': {
        ga: {
            category: 'Discussion',
            action: 'Discussion user invited'
        },
        intercom: {
            action: 'Discussion user invited'
        }
    },
    'DISCUSSION.ARCHIVE': {
        ga: {
            category: 'Discussion',
            action: 'Discussion archived'
        },
        intercom: {
            action: 'Discussion archived'
        }
    },
    'DISCUSSION.UNARCHIVE': {
        ga: {
            category: 'Discussion',
            action: 'Discussion unarchived'
        },
        intercom: {
            action: 'Discussion unarchived'
        }
    },
    'DISCUSSION.LEAVE': {
        ga: {
            category: 'Discussion',
            action: 'Discussion left'
        },
        intercom: {
            action: 'Discussion left'
        }
    },

    'CHAT.POST': {
        ga: {
            category: 'Chat',
            action: 'Chat message posted'
        },
        intercom: {
            action: 'Chat message posted'
        }
    },

    'CHAT.REACTION': {
        ga: {
            category: 'Chat',
            action: 'Chat reaction'
        },
        intercom: {
            action: 'Chat reaction'
        }
    },

    'CHAT.CREATE_GROUP': {
        ga: {
            category: 'Chat',
            action: 'Group chat created'
        },
        intercom: {
            action: 'Group chat created'
        },
        encharge: {
            name: 'Group chat created'
        }
    },

    'CHAT.CREATE_PERSONAL': {
        ga: {
            category: 'Chat',
            action: 'Personal chat created'
        },
        intercom: {
            action: 'Personal chat created'
        },
        encharge: {
            name: 'Personal chat created'
        }
    },

    'DISCUSSION.POST': {
        ga: {
            category: 'Discussions',
            action: 'Discussion message posted'
        },
        intercom: {
            action: 'Discussion message posted'
        }
    },
    'DISCUSSION.THREAD_START': {
        ga: {
            category: 'Discussions',
            action: 'Thread started'
        },
        intercom: {
            action: 'Thread started'
        }
    },
    'DISCUSSION.TASK_CREATE': {
        ga: {
            category: 'Discussions',
            action: 'Discussion task created'
        },
        intercom: {
            action: 'Discussion task created'
        }
    },

    'MESSAGE.REMOVE': {
        ga: {
            category: 'Message',
            action: 'Message removed'
        },
        intercom: {
            action: 'Message removed'
        }
    },
    'MESSAGE.EDIT': {
        ga: {
            category: 'Message',
            action: 'Message edited'
        },
        intercom: {
            action: 'Message edited'
        }
    },
    'MESSAGE.POST': {
        ga: {
            category: 'Message',
            action: 'Message posted'
        },
        intercom: {
            action: 'Message posted'
        }
    },
    'MESSAGE.UNREAD_VIEW': {
        ga: {
            category: 'Message',
            action: 'Unread message viewed'
        },
        intercom: {
            action: 'Unread message viewed'
        }
    },

    'FILE.UPLOAD': {
        ga: {
            category: 'File',
            action: 'File uploaded'
        },
        intercom: {
            action: 'File uploaded'
        }
    },
    'FILE.ARCHIVE': {
        ga: {
            category: 'File',
            action: 'File archived'
        },
        intercom: {
            action: 'File archived'
        }
    },
    'FILE.DELETE': {
        ga: {
            category: 'File',
            action: 'File deleted'
        },
        intercom: {
            action: 'File deleted'
        }
    },
    'FILE.UNARCHIVE': {
        ga: {
            category: 'File',
            action: 'File unarchived'
        },
        intercom: {
            action: 'File unarchived'
        }
    },
    'FILE.VIEW': {
        ga: {
            category: 'File',
            action: 'File viewed'
        },
        intercom: {
            action: 'File viewed'
        }
    },
    'FILE.DOWNLOAD': {
        ga: {
            category: 'File',
            action: 'File downloaded'
        },
        intercom: {
            action: 'File downloaded'
        }
    },
    'FILE.URL_COPY': {
        ga: {
            category: 'File',
            action: 'File url copied'
        },
        intercom: {
            action: 'File url copied'
        }
    },

    'DOC.CREATE': {
        ga: {
            category: 'Doc',
            action: 'Nifty Doc Created'
        },
        intercom: {
            action: 'Nifty Doc Created'
        },
        encharge: {
            name: 'Nifty Doc Created'
        }
    },

    'DOC.CREATE_GOOGLE': {
        ga: {
            category: 'Doc',
            action: 'Google Doc Created'
        },
        intercom: {
            action: 'Google Doc Created'
        },
        encharge: {
            name: 'Google Doc Created'
        }
    },
    'DOC.VIEW': {
        ga: {
            category: 'Doc',
            action: 'Doc view'
        },
        intercom: {
            action: 'Doc view'
        }
    },
    'DOC.EDIT': {
        ga: {
            category: 'Doc',
            action: 'Doc edit'
        },
        intercom: {
            action: 'Doc edit'
        }
    },
    'DOC.USERS_ASSIGN': {
        ga: {
            category: 'Doc',
            action: 'Doc assigned'
        },
        intercom: {
            action: 'Doc assigned'
        }
    },
    'DOC.ARCHIVE': {
        ga: {
            category: 'Doc',
            action: 'Doc archive'
        },
        intercom: {
            action: 'Doc archive'
        }
    },
    'DOC.UNARCHIVE': {
        ga: {
            category: 'Doc',
            action: 'Doc unarchive'
        },
        intercom: {
            action: 'Doc unarchive'
        }
    },
    'DOC.URL_COPY': {
        ga: {
            category: 'Doc',
            action: 'Doc url copied'
        },
        intercom: {
            action: 'Doc url copied'
        }
    },
    'DOC.REMOVE': {
        ga: {
            category: 'Doc',
            action: 'Doc removed'
        },
        intercom: {
            action: 'Doc removed'
        }
    },

    'TASKLIST.CREATE': {
        ga: {
            category: 'Tasklist',
            action: 'Tasklist created'
        },
        intercom: {
            action: 'Tasklist created'
        }
    },
    'TASKLIST.REMOVE': {
        ga: {
            category: 'Tasklist',
            action: 'Tasklist removed'
        },
        intercom: {
            action: 'Tasklist removed'
        }
    },

    'TASK.CREATE': {
        ga: {
            category: 'Task',
            action: 'Task created'
        },
        intercom: {
            action: 'Task created'
        },
        encharge: {
            name: 'Task created'
        }
    },
    'TASK.ARCHIVE': {
        ga: {
            category: 'Task',
            action: 'Task archived'
        },
        intercom: {
            action: 'Task archived'
        }
    },
    'TASK.UNARCHIVE': {
        ga: {
            category: 'Task',
            action: 'Task unarchived'
        },
        intercom: {
            action: 'Task unarchived'
        }
    },
    'TASK.REMOVE': {
        ga: {
            category: 'Task',
            action: 'Task removed'
        },
        intercom: {
            action: 'Task removed'
        }
    },
    'TASK.DESCRIPTION_EDIT': {
        ga: {
            category: 'Task',
            action: 'Task description edited'
        },
        intercom: {
            action: 'Task description edited'
        }
    },
    'TASK.USERS_ASSIGN': {
        ga: {
            category: 'Task',
            action: 'Task assigned'
        },
        intercom: {
            action: 'Task assigned'
        }
    },
    'TASK.DEADLINE_ADD': {
        ga: {
            category: 'Task',
            action: 'Task deadline added'
        },
        intercom: {
            action: 'Task deadline added'
        }
    },
    'TASK.DEADLINE_EDIT': {
        ga: {
            category: 'Task',
            action: 'Task deadline edited'
        },
        intercom: {
            action: 'Task deadline edited'
        }
    },
    'TASK.DEADLINE_REMOVE': {
        ga: {
            category: 'Task',
            action: 'Task deadline removed'
        },
        intercom: {
            action: 'Task deadline removed'
        }
    },
    'TASK.LIST_SWITCH': {
        ga: {
            category: 'Task',
            action: 'Task list switched'
        },
        intercom: {
            action: 'Task list switched'
        }
    },
    'TASK.URL_COPY': {
        ga: {
            category: 'Task',
            action: 'Task url copied'
        },
        intercom: {
            action: 'Task url copied'
        }
    },
    'TASK.EXPORT': {
        ga: {
            category: 'Task',
            action: 'TaskS Report Expored'
        },
        intercom: {
            action: 'TaskS Report Expored'
        }
    },
    'TASK_SINGLE.COMPLETE': {
        ga: {
            category: 'Task completions',
            action: 'Completed from single task view'
        },
        intercom: {
            action: 'Completed from single task view'
        }
    },
    'TASK.COMPLETE': {
        ga: {
            category: 'Task completions',
            action: 'Completed from all task view'
        },
        intercom: {
            action: 'Completed from all task view'
        }
    },

    'TASK_SCREEN.KANBAN': {
        ga: {
            category: 'User Task View',
            action: 'Kanban view mode'
        },
        intercom: {
            action: 'Kanban view mode'
        }
    },

    'TASK_SCREEN.LIST': {
        ga: {
            category: 'User Task View',
            action: 'List view mode'
        },
        intercom: {
            action: 'List view mode'
        }
    },

    'SUBTASK.CREATE': {
        ga: {
            category: 'Subtask',
            action: 'Subtask created'
        },
        intercom: {
            action: 'Subtask created'
        }
    },
    'SUBTASK.USERS_ASSIGN': {
        ga: {
            category: 'Subtask',
            action: 'Subask assigned'
        },
        intercom: {
            action: 'Subtask assigned'
        }
    },
    'SUBTASK.DEADLINE_ADD': {
        ga: {
            category: 'Subtask',
            action: 'Subtask deadline added'
        },
        intercom: {
            action: 'Subtask deadline added'
        }
    },
    'SUBTASK.DEADLINE_EDIT': {
        ga: {
            category: 'Subtask',
            action: 'Subtask deadline edited'
        },
        intercom: {
            action: 'Subtask deadline edited'
        }
    },
    'SUBTASK.DEADLINE_REMOVE': {
        ga: {
            category: 'Subtask',
            action: 'Subtask deadline removed'
        },
        intercom: {
            action: 'Subtask deadline removed'
        }
    },
    'SUBTASK.COMPLETE': {
        ga: {
            category: 'Subtask',
            action: 'Subask completed'
        },
        intercom: {
            action: 'Subtask completed'
        }
    },
    'SUBTASK.ACTIVATE': {
        ga: {
            category: 'Subtask',
            action: 'Subtask activated'
        },
        intercom: {
            action: 'Subtask activated'
        }
    },
    'SUBTASK.REMOVE': {
        ga: {
            category: 'Subtask',
            action: 'Subtask removed'
        },
        intercom: {
            action: 'Subtask removed'
        }
    },

    'SEARCH.RESULT_SELECT': {
        ga: {
            category: 'Search',
            action: 'Search result selected'
        },
        intercom: {
            action: 'Search result selected'
        }
    },

    'USER.AVATAR_UPLOAD': {
        ga: {
            category: 'User',
            action: 'User uploaded avatar'
        },
        intercom: {
            action: 'User uploaded avatar'
        }
    },
    'USER.EMAIL_CHANGE': {
        ga: {
            category: 'User',
            action: 'User email changed'
        },
        intercom: {
            action: 'User email changed'
        }
    },
    'USER.LOGOUT': {
        ga: {
            category: 'User',
            action: 'User logged out'
        },
        intercom: {
            action: 'User logged out'
        }
    },
    'USER.LOGIN': {
        ga: {
            category: 'User',
            action: 'User logged in'
        },
        intercom: {
            action: 'User logged in'
        }
    },
    'USER.INVITE': {
        ga: {
            category: 'User',
            action: 'Invited a team member'
        },
        intercom: {
            action: 'Invited a team member'
        }
    },

    'MILESTONE.CREATE': {
        ga: {
            category: 'Milestone',
            action: 'Milestone Created'
        },
        intercom: {
            action: 'Milestone Created'
        },
        encharge: {
            name: 'Milestone Created'
        }
    },
    'MILESTONE.REMOVE': {
        ga: {
            category: 'Milestone',
            action: 'Milestone removed'
        },
        intercom: {
            action: 'Milestone removed'
        }
    },

    'ROADMAP.VIEW': {
        ga: {
            category: 'Roadmap',
            action: 'Roadmap view'
        },
        intercom: {
            action: 'Roadmap view'
        }
    },
    'ROADMAP.VIEW_CHANGE': {
        ga: {
            category: 'Roadmap',
            action: 'Roadmap view change'
        },
        intercom: {
            action: 'Roadmap view change'
        }
    },
    'INVITE.CLICK': {
        ga: {
            category: 'Invite',
            action: 'Invite Click'
        },
        intercom: {
            action: 'Invite Click'
        }
    },
    'INVITE.ACCEPT': {
        ga: {
            category: 'Invite',
            action: 'Accepted invite'
        },
        intercom: {
            action: 'Accepted invite'
        }
    },
    'INVITE.ACCEPT_LINK': {
        ga: {
            category: 'Invite',
            action: 'Accepted invite from link'
        },
        intercom: {
            action: 'Accepted invite from link'
        }
    },
    'INVITE.ACCEPT_SSO': {
        ga: {
            category: 'Invite',
            action: 'Accepted invite from SSO'
        },
        intercom: {
            action: 'Accepted invite from SSO'
        }
    },
    'SEARCH': {
        ga: {
            category: 'Search',
            action: 'Search'
        },
        intercom: {
            action: 'Search'
        }
    },
    'TRIAL_UPGRADE_BANNER.CLICK': {
        ga: {
            category: 'Upgrade Banner',
            action: 'Click'
        },
        intercom: {
            action: 'Upgrade Banner Click'
        }
    },
    'ERROR.DISPLAY': {
        ga: {
            category: 'Error',
            action: 'Error display'
        },
        intercom: {
            action: 'Error display'
        }
    },
    'TRELLO_IMPORT.CLICK': {
        ga: {
            category: 'Import',
            action: 'Import Trello click'
        },
        intercom: {
            action: 'Import Trello click'
        }
    },
    'TRELLO_IMPORT.SUCCESS': {
        ga: {
            category: 'Import',
            action: 'Import Trello success'
        },
        intercom: {
            action: 'Import Trello success'
        }
    },
    'TOUR.START': {
        ga: {
            category: 'Tour',
            action: 'Tour Start'
        },
        intercom: {
            action: 'Tour Start'
        }
    },
    'TOUR.REJECT': {
        ga: {
            category: 'Tour',
            action: 'Tour Reject'
        },
        intercom: {
            action: 'Tour Reject'
        }
    },
    'PUSH_NOTIFICATIONS.ENABLE': {
        ga: {
            category: 'Push Notification',
            action: 'Push Notification Enable'
        },
        intercom: {
            action: 'Push Notification Enable'
        }
    },

    'ACCOUNT.CREATE': {
        ga: {
            category: 'Account',
            action: 'Account created'
        },
        intercom: {
            action: 'Account created'
        }
    },

    'PLAN_QUOTA_REACHED.TRIGGER': {
        ga: {
            category: 'Plan',
            action: 'Plan quota reached'
        },
        intercom: {
            action: 'Plan quota reached'
        }
    },
    'PLAN_QUOTA_REACHED_UPGRADE.CLICK': {
        ga: {
            category: 'Plan',
            action: 'Plan upgrade click from reached quota'
        },
        intercom: {
            action: 'Plan upgrade click from reached quota'
        }
    },

    'OVERVIEW.VIEW': {
        ga: {
            category: 'Overview',
            action: 'Overview view'
        },
        intercom: {
            action: 'Overview view'
        }
    },

    'SELF_DETAILS.VIEW': {
        ga: {
            category: 'Self Details',
            action: 'Self Details view'
        },
        intercom: {
            action: 'Self Details view'
        }
    },

    'HEADER_PROJECT_NAV_ITEM.CLICK': {
        ga: {
            category: 'Header project nav item',
            action: 'Header project nav item click'
        },
        intercom: {
            action: 'Header project nav item click'
        }
    },
    'SIDEBAR_PROJECT_NAV_ITEM.CLICK': {
        ga: {
            category: 'Sidebar',
            action: 'Sidebar project nav item click'
        },
        intercom: {
            action: 'Sidebar project nav item click'
        }
    },
    'ZOOM.START_DISCUSSION': {
        ga: {
            category: 'Zoom',
            action: 'Meeting started discussions '
        }
    },
    'ZOOM.START_CHAT': {
        ga: {
            category: 'Zoom',
            action: 'Meeting started chat '
        }
    },
    'PRODUCT_UPDATES.CANCEL': {
        ga: {
            category: 'Product Updates',
            action: 'Cancel'
        }
    },
    'PRODUCT_UPDATES.READ': {
        ga: {
            category: 'Product Updates',
            action: 'Read'
        }
    },
    'PRODUCT_UPDATES.WATCH': {
        ga: {
            category: 'Product Updates',
            action: 'Watch'
        }
    }
};

const canTrack = () => config.EVENTS_TRACKING_ENABLED && !trackingBlocked;

const getDefaultProps = () => {
    const team = getCurrentTeam();
    const user = getCurrentUser();

    if (!team || !user) {
        return {};
    }

    return {
        teamName: team.name,
        teamUrl: team.url,
        userRole: getRoleLabel(user.role),
        pageName: typeof document !== 'undefined' && document.title
    }
};

export const trackEvent = (action, params = {}) => {
    return new Promise(resolve => {
        if (!config.EVENTS_TRACKING_ENABLED || !(action in trackConsts) || trackingBlocked) {
            resolve();

            return;
        }

        if (config.GA_TRACKING_ENABLED && 'ga' in trackConsts[action]) {
            GA.event(Object.assign(trackConsts[action].ga, Object.assign(trackConsts[action].ga.options || {}, params)));
        }

        if (config.INTERCOM_ENABLED && 'intercom' in trackConsts[action]) {
            Intercom.trackEvent(trackConsts[action].intercom.action, Object.assign(trackConsts[action].intercom.options || {}, params));
        }

        if (EncTracking && 'encharge' in trackConsts[action]) {
            EncTracking.track({
                name: trackConsts[action].encharge.name,
                properties: Object.assign({}, getDefaultProps(), (trackConsts[action].encharge.props || {}), params)
            });
        }

        resolve();
    });
}

export const dataLayerPush = (event, data) => {
    if (!canTrack() || !DataLayerPush) {
        return;
    }

    let eventData = { event };

    if (data && typeof data === 'object') {
        eventData = {
            ...eventData,
            ...data
        };
    }

    DataLayerPush(eventData);
}

export const setTrackingIdentifyDetails = async (user = {}, team = {}, teamsCount, projectsCount) => {
    if (!config.EVENTS_TRACKING_ENABLED || trackingBlocked) {
        return;
    }

    if (!user || !team) {
        return;
    }

    if (config.BLOCK_EXCLUDED_ACCOUNTS && (config.EXCLUDED_ACCOUNTS.filter(e => e.test(user.email)).length || config.EXCLUDED_TEAMS.filter(e => e.test(team.url)).length)) {
        trackingBlocked = true;
        return;
    }

    if (window.profitwell) {
        window.profitwell('start', {
            'user_email': user.email
        });
    }

    if (config.GA_TRACKING_ENABLED) {
        GA.setUser(user.id);
    }

    const roleProp = {};
    switch (user.role) {
        case 'owner':
            roleProp.is_owner = true;
            break;

        case 'manager':
            roleProp.is_admin = true;
            break;

        case 'regular':
            roleProp.is_member = true;
            break;

        case 'client':
            roleProp.is_guest = true;
            break;

        default:
            break;
    }

    if (config.INTERCOM_ENABLED) {
        const intercomProps = {
            email: user.email,
            name: user.name,
            team: team.url,
            theme: user.theme,
            plan: team.plan,
            team_url: `https://${team.url}.nifty.pm`,
            create_project_url: `https://${team.url}.nifty.pm/create-project`,
            upgrade_url: `https://${team.url}.nifty.pm/upgrade`,
            activate_url: `https://${team.url}.nifty.pm/activate`,
            update_billing_url: `https://${team.url}.nifty.pm/update-billing`,
            invite_team_url: `https://${team.url}.nifty.pm/settings/team/current/people`,
            ...roleProp,
            company: {
                id: team.id,
                url: team.url,
                plan: team.plan,
                name: team.name,
                created_at: team.created_at,
                subscription_start_date: team.current_period_start,
                subscription_end_date: team.current_period_end,
                subscription_id: team.source_id
            }
        };

        Intercom.update(intercomProps);
    }

    if (EncTracking) {
        const encTrackingProps = {
            user_id: user.id,
            signed_up: user.signup_date,
            email: user.email,
            ...roleProp,
            plan: team.plan
        };

        EncTracking.identify(encTrackingProps);

        const ip = await getUserIP();
        EncTracking.identify({ ip });
    }
}

export const setPushNotificationsState = state => {
    if (!config.EVENTS_TRACKING_ENABLED || trackingBlocked) {
        return;
    }

    if (config.INTERCOM_ENABLED) {
        Intercom.update({
            notificationsEnabled: state
        });
    }
}

export const trackTiming = ({ type, label, time }) => {
    if (!config.EVENTS_TRACKING_ENABLED || trackingBlocked) {
        return;
    }

    const trackParams = {
        label,
        value: time
    };

    if (type === 'AJAX_LOAD') {
        trackParams.category = 'AJAX';
        trackParams.variable = 'load';
    }

    // if (config.GA_TRACKING_ENABLED) {
    //     ReactGA.timing(trackParams);
    // }

    // if (config.INTERCOM_ENABLED) {
    //     Intercom.trackEvent('AJAX loaded', trackParams);
    // }
}

export const trackPageView = (pageUrl) => {
    if (!config.EVENTS_TRACKING_ENABLED || trackingBlocked) {
        return;
    }

    if (config.GA_TRACKING_ENABLED) {
        GA.pageView(pageUrl);
    }

    // if (config.INTERCOM_ENABLED) {
    //     Intercom.trackEvent('Page viewed', {
    //         url: pageUrl
    //     });
    // }
}

export const setUserTrackingProp = (key, prop) => {
    if (!config.EVENTS_TRACKING_ENABLED || trackingBlocked) {
        return;
    }

    if (Intercom && config.INTERCOM_ENABLED) {
        const pair = {};
        pair[key] = prop;
        Intercom.update(pair);
    }

    EncTracking && EncTracking.track({
        name: 'update',
        user: {
            [key]: prop
        }
    });
}

let sessions = [];

export const startTrackSession = type => {
    if (!config.EVENTS_TRACKING_ENABLED || trackingBlocked) {
        return;
    }

    if (sessions.some(session => session.type === type)) {
        return;
    }

    sessions.push({
        type,
        timestamp: Date.now()
    });
}

export const stopTrackSession = type => {
    if (!config.EVENTS_TRACKING_ENABLED || trackingBlocked) {
        return;
    }

    const session = sessions.find(session => session.type === type);

    if (!session) {
        return;
    }

    sessions = sessions.filter(s => s !== session);

    GA.timing({
        category: 'Screen Sessions',
        variable: session.type,
        value: Date.now() - session.timestamp
    });
}

export const signupInIntercom = (name, email, provider) => {
    Intercom && Intercom.update({
        name,
        email
    });

    Intercom && Intercom.trackEvent('signup', {
        name,
        email,
        provider
    });
}

export const trackSignup = (userId, name, email, signupProvider) => {
    if (GTagTrackEvent) {
        GTagTrackEvent('conversion', {'send_to': 'AW-748502255/tAwhCKDX8KEBEO_59OQC'});
    }

    signupInIntercom(name, email, signupProvider);

    trackEvent('ACCOUNT.CREATE', {
        email,
        name,
        signupProvider
    });

    if (typeof document !== 'undefined' && document.createElement) {
        var capterra_vkey = '456df9ba5944bf16fa521e3587373c96',
            capterra_vid = '2119521',
            capterra_prefix = (('https:' === document.location.protocol) ? 'https://ct.capterra.com' : 'http://ct.capterra.com');
        (function() {
            var ct = document.createElement('script'); ct.type = 'text/javascript'; ct.async = true;
            ct.src = capterra_prefix + '/capterra_tracker.js?vid=' + capterra_vid + '&vkey=' + capterra_vkey;
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ct, s);
        })();
    }
}

export const logout = () => {
    Intercom.logout();
}
